import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-invoice-banner',
  templateUrl: './invoice-banner.component.html',
  styleUrls: ['./invoice-banner.component.scss']
})
export class InvoiceBannerComponent {
  @Input() invoicesList: any[] = [];
  currentIndex = 0;

  constructor(private router: Router) {}

  get currentInvoice() {
    return this.invoicesList?.[this.currentIndex];
  }

  get totalPages() {
    return this.invoicesList?.length || 0;
  }

  get currentPage() {
    return this.currentIndex + 1;
  }

  nextInvoice() {
    if (this.currentIndex < this.totalPages - 1) {
      this.currentIndex++;
    }
  }

  previousInvoice() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
  }

  goToInvoicePage() {
    this.router.navigate(['/invoices']);
  }
}
